import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-alert-detail',
	path: '/jira/ops/teams/:teamId/alerts/:id',
	exact: true,
};
